"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageTwoForcedContent;
var _react = _interopRequireDefault(require("react"));
var _Notebook = _interopRequireDefault(require("../svg/Notebook"));
var _utils = require("../../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function PageTwoForcedContent(_ref) {
  var {
    currentExpenses
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "eyebrow"
  }, "CALCULATING CURRENT EXPENSES")), /*#__PURE__*/_react.default.createElement("h4", {
    className: "margin-bottom-0"
  }, "Current Total Monthly Expenses"), /*#__PURE__*/_react.default.createElement("h2", {
    className: "margin-top-8px mm-spacing"
  }, (0, _utils.numberToCurrencyString)(currentExpenses)), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement(_Notebook.default, {
    className: "align-top"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block rig-sideContent-title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sideContent-smallTitle"
  }, "HELPFUL HINT"), /*#__PURE__*/_react.default.createElement("h4", {
    className: "margin-top-0 mm-spacing--minor"
  }, "Itemize Your Expenses"))), /*#__PURE__*/_react.default.createElement("ul", {
    className: "rig-sideContent-ul"
  }, /*#__PURE__*/_react.default.createElement("li", null, "Sometimes it's easier to detail all your expenses in each category rather than come up with a total."), /*#__PURE__*/_react.default.createElement("li", null, "Use the \"Itemize Your Expenses\" link to break down your current monthly expenses \u2014 and see what you may have missed.")));
}